import { Pipe, PipeTransform } from '@angular/core';
import {RequestedAction, SchoolRole} from '@app/core/model/integration-models';

@Pipe({
    name: 'changedSchoolRoles'
})
export class ChangedSchoolRolesPipe implements PipeTransform {

    transform(activatedRolesForSchool: SchoolRole[], requestedAction: RequestedAction): unknown {
        if (requestedAction) {
            return activatedRolesForSchool
                .filter((role: SchoolRole) => <RequestedAction>role.requestedAction === <RequestedAction>requestedAction);
        } else {
            return activatedRolesForSchool;
        }
    }
}
